import { AccountCreditCardOutlineIcon } from './AccountCreditCardOutlineIcon';

/**
 * author: Jeff Anders
 * id A19CDCEF-1CFD-4BFE-A323-F66C6EBF0FCE
 * name account-credit-card-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-credit-card-outline.svg
 * tags
 * - Account / User 
 * - Banking 
 */
export const CardholderOutlineIcon = AccountCreditCardOutlineIcon;
export default CardholderOutlineIcon